export default __webpack_public_path__ + "static/media/t_wdt_c_1_2.3aa27bca.mp3";